import { render, staticRenderFns } from "./InvoiceDisputesTable.vue?vue&type=template&id=005713a4&scoped=true&"
import script from "./InvoiceDisputesTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDisputesTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDisputesTable.vue?vue&type=style&index=0&id=005713a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005713a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005713a4')) {
      api.createRecord('005713a4', component.options)
    } else {
      api.reload('005713a4', component.options)
    }
    module.hot.accept("./InvoiceDisputesTable.vue?vue&type=template&id=005713a4&scoped=true&", function () {
      api.rerender('005713a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_InvoiceDisputes/InvoiceDisputesTable.vue"
export default component.exports